import { usePosShopStore } from '~/stores/pos.shop'

export const PLAN = {
  INVENTORY_MIN: 890,
  EMPLOYEE_PIN_MIN: 890,
  KITCHEN_PRINT_MIN: 1390,
  // Multi-device run modes (Terminal / Read Only / 2nd Cashier) require plan >= 1390.
  // Lower packages get the single main Cashier only.
  MULTI_DEVICE_MIN: 1390,
} as const

export function currentPlan(): number {
  const data = usePosShopStore().data as any
  return Number(data?.PackagePlan || data?.packagePlan || 0)
}

export function hasPlan(min: number): boolean {
  return currentPlan() >= min
}

// The Employee PIN feature (lock screen + PIN management) requires plan >= 890.
// Package 590 has no PIN feature at all — it runs unlocked as a default "Admin".
export function isEmployeePinEnabled(): boolean {
  return hasPlan(PLAN.EMPLOYEE_PIN_MIN)
}
